export default "__VITE_ASSET__Dyk0y62L__"